import React, { useEffect, useState } from 'react';
import { ConstructorEventUpdateSQLStatus } from '../../../Event/event';

const ShapeTrainAdventure = () => {
  const shapeStyles = {
    shapeBase: {
      width: 100,
      height: 100,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      cursor: 'grab',
      transition: 'transform 0.3s ease',
    },
    circle: { borderRadius: '50%', backgroundColor: '#f44336' },
    square: { backgroundColor: '#4caf50' },
    triangle: {
      width: 0,
      height: 0,
      borderLeft: '50px solid transparent',
      borderRight: '50px solid transparent',
      borderBottom: '100px solid #2196f3',
      background: 'none',
    },
    rectangle: {
      width: 120,
      height: 70,
      backgroundColor: '#ff9800',
    },
    oval: {
      width: 120,
      height: 70,
      borderRadius: '50%',
      backgroundColor: '#9c27b0',
    },
    star: {
      backgroundImage: 'url(https://upload.wikimedia.org/wikipedia/commons/4/44/Plain_Yellow_Star.png)',
      backgroundSize: 'cover',
      width: 100,
      height: 100,
    },
    cube: {
  position: 'relative',
  width: 80,
  height: 80,
  background: 'linear-gradient(135deg, #00bcd4, #0097a7)',
  border: '2px solid rgba(0,0,0,0.2)',
  boxShadow: `
    5px 5px 0 #0097a7,
    10px 10px 0 #007c91,
    15px 15px 5px rgba(0,0,0,0.3)
  `,
  transform: 'rotateX(20deg) rotateY(20deg)',
  transformStyle: 'preserve-3d',
  borderRadius: 6,
},

    cylinder: {
      backgroundColor: '#00bcd4',
      width: 100,
      height: 100,
      borderRadius: '50% / 10%',
    },
  };

  const [shapesList] = useState([
    { name: 'CIRCLE', class: 'circle' },
    { name: 'SQUARE', class: 'square' },
    { name: 'TRIANGLE', class: 'triangle' },
    { name: 'RECTANGLE', class: 'rectangle' },
    { name: 'OVAL', class: 'oval' },
    { name: 'STAR', class: 'star' },
    { name: 'CUBE', class: 'cube' },
    { name: 'CYLINDER', class: 'cylinder' },
  ]);

  const [currentChallenge, setCurrentChallenge] = useState([]);
  const [train, setTrain] = useState([]);
  const [shuffledIndices, setShuffledIndices] = useState([]);
  const [transformTrain, setTransformTrain] = useState(false);

  const generateChallenge = () => {
    const shuffledShapes = [...shapesList].sort(() => 0.5 - Math.random()).slice(0, 5);
    setCurrentChallenge(shuffledShapes);

    const newTrain = shuffledShapes.map((shape) => ({
      ...shape,
      filled: false,
      wrong: false,
    }));

    setTrain(newTrain);

    const indices = [...Array(newTrain.length).keys()];
    setShuffledIndices(indices.sort(() => 0.5 - Math.random()));

    setTransformTrain(false);
  };

  useEffect(() => {
    generateChallenge();
  }, []);

  const handleDragStart = (e, name) => {
    e.dataTransfer.setData('shape', name);
  };

  const handleDrop = (e, compartmentIndex) => {
    const droppedShape = e.dataTransfer.getData('shape');
    const correctShape = train[compartmentIndex].name;

    const updatedTrain = [...train];

    if (droppedShape === correctShape) {
      updatedTrain[compartmentIndex].filled = true;
      checkWin(updatedTrain);
    } else {
      updatedTrain[compartmentIndex].wrong = true;
      setTimeout(() => {
        updatedTrain[compartmentIndex].wrong = false;
        setTrain([...updatedTrain]);
      }, 1000);
    }

    setTrain(updatedTrain);
  };

  const checkWin = (updatedTrain) => {
    const done = updatedTrain.every((comp) => comp.filled);
    if (done) {
      const sound = document.getElementById('soundEffect');
      sound.currentTime = 0;
      sound.play();
      setTransformTrain(true);
      setTimeout(generateChallenge, 3000);
      const responsedata = ConstructorEventUpdateSQLStatus();
      console.log("Event completed", responsedata);
    }
  };

  const styles = {
    body: {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      flexDirection: 'column',
      minHeight: '100vh',
      background: 'linear-gradient(to bottom, #a1ffce,rgb(223, 241, 83))',
      overflow: 'hidden',
      textAlign: 'center',
      padding: '20px',
    },
    header: {
      background: '#ffeb3b',
      padding: '20px 40px',
      fontSize: '42px',
      fontWeight: 'bold',
      borderRadius: '20px',
      boxShadow: '0 0 25px rgba(0,0,0,0.2)',
      animation: 'pulse 2s infinite',
    },
    container: {
      background: 'white',
      borderRadius: '30px',
      padding: '30px',
      boxShadow: '0 0 30px rgba(0,0,0,0.2)',
      width: '90%',
      maxWidth: '1000px',
      marginTop: '30px',
    },
    shapesContainer: {
      display: 'flex',
      justifyContent: 'center',
      gap: 50,
      marginBottom: 40,
      flexWrap: 'wrap',
    },
    train: {
      display: 'flex',
      alignItems: 'flex-end',
      justifyContent: 'center',
      marginTop: 40,
      position: 'relative',
      transform: transformTrain ? 'translateX(calc(100vw + 200px))' : 'translateX(0)',
      transition: 'transform 2s ease-in-out',
    },
    engine: {
      width: 150,
      height: 130,
      backgroundImage: 'url(https://upload.wikimedia.org/wikipedia/commons/e/ed/Steam_locomotive_icon.png)',
      backgroundSize: 'contain',
      backgroundRepeat: 'no-repeat',
      backgroundPosition: 'center',
    },
    track: {
      position: 'absolute',
      bottom: 0,
      left: 0,
      width: '100%',
      height: 35,
      background: 'repeating-linear-gradient(-45deg, #795548, #795548 10px, #d7ccc8 10px, #d7ccc8 20px)',
      zIndex: -1,
    },
    compartment: (filled, wrong) => ({
      width: 120,
      height: 120,
      background: filled ? '#a5d6a7' : '#fff176',
      border: '3px dashed #795548',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      fontWeight: 'bold',
      borderRadius: 12,
      fontSize: 16,
      color: wrong ? '#f44336' : '#3e2723',
      transition: 'all 0.3s ease',
    }),
    button: {
      marginTop: 40,
      padding: '12px 30px',
      backgroundColor: '#ff4081',
      color: 'white',
      border: 'none',
      borderRadius: 10,
      fontSize: 20,
      cursor: 'pointer',
      boxShadow: '0 4px 10px rgba(0,0,0,0.3)',
      transition: 'transform 0.2s ease',
    },
  };

  return (
    <div style={styles.body}>
      <header style={styles.header}>🚂 Shape Train Adventure</header>
      <div style={styles.container}>
        <div style={styles.shapesContainer}>
          {currentChallenge.map((shape, i) => (
            <div
              key={i}
              draggable
              onDragStart={(e) => handleDragStart(e, shape.name)}
              style={{ ...shapeStyles.shapeBase, ...shapeStyles[shape.class] }}
              onMouseOver={(e) => (e.currentTarget.style.transform = 'scale(1.2)')}
              onMouseOut={(e) => (e.currentTarget.style.transform = 'scale(1)')}
            ></div>
          ))}
        </div>

        <div style={styles.train}>
          <div style={styles.engine}></div>
          {shuffledIndices.map((idx) => {
            const comp = train[idx];
            return (
              <div
                key={idx}
                style={styles.compartment(comp.filled, comp.wrong)}
                onDragOver={(e) => e.preventDefault()}
                onDrop={(e) => handleDrop(e, idx)}
              >
                {comp.filled ? '✅' : comp.wrong ? '❌' : comp.name}
              </div>
            );
          })}
        </div>

        <div style={styles.track}></div>

        <button
          style={styles.button}
          onClick={generateChallenge}
          onMouseOver={(e) => (e.currentTarget.style.transform = 'scale(1.1)')}
          onMouseOut={(e) => (e.currentTarget.style.transform = 'scale(1)')}
        >
          🔁 New Challenge
        </button>
      </div>

      <audio id="soundEffect" src="https://www.soundjay.com/transportation/train-whistle-01.mp3" />
    </div>
  );
};

export default ShapeTrainAdventure;
